import { atom } from 'jotai'
import { atomFamily, atomWithStorage } from 'jotai/utils'

import {
  type ColumnLayout,
  EMPTY_COLUMN_LAYOUT,
  normalizeColumnLayout
} from '../../-models/column-layout'

/** テナント・ユーザー・画面で分ける（確定版 §2.4。同じブラウザで別ユーザー・別テナントに切り替えても混ざらない） */
const getColumnLayoutStorageKey = ({ tenantKey, userId }: Params) =>
  `shipment-orders-column-layout:${tenantKey}:${String(userId)}`

type Params = { tenantKey: string; userId: number }

/**
 * 配送依頼一覧の列レイアウト（並び・幅・表示/非表示・固定）Atom（テナント・ユーザー単位、#3690 VOC_PJ-577）
 * - localStorage で永続化する。別 PC・別ブラウザ・キャッシュクリア後は既定のレイアウトから始まる
 * - 拠点を切り替えても引き継ぐ（atomFamily の比較はテナントとユーザーだけ。拠点ごとの列の違いは
 *   column-layout.ts のマージで吸収する）
 * - 保存値は読むたびに normalize する。壊れた値・旧版の値でも画面は既定のレイアウトで出る
 */
export const shipmentOrdersColumnLayoutAtomFamily = atomFamily(
  (params: Params) => {
    // getOnInit: true — 初回描画から保存値で列を組む。false（既定）だと既定の幅で一度描いてから
    // 保存値の幅へ切り替わり、列がちらつく（FIX 仕様書 §5 の FOUC）
    const base = atomWithStorage<unknown>(
      getColumnLayoutStorageKey(params),
      EMPTY_COLUMN_LAYOUT,
      undefined,
      { getOnInit: true }
    )

    return atom(
      (get) => normalizeColumnLayout(get(base)),
      (_get, set, next: ColumnLayout) => set(base, next)
    )
  },
  (a, b) => a.tenantKey === b.tenantKey && a.userId === b.userId
)
